export default __webpack_public_path__ + "images/SS.c959e66.png";